import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../auth/useAuth';
import Logo from '../components/Logo';

export default function Login() {
  const { account, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (account) navigate('/dashboard', { replace: true });
  }, [account, navigate]);

  return (
    <div className="login-page">
      <div className="login-card">
        <Logo variant="mark" size={80} />
        <h1>Proxemics Portal</h1>
        <p className="muted">
          Sign in with your Proxemics Consulting email and password to continue.
        </p>
        <button className="btn btn-primary btn-lg" onClick={login}>
          Sign In
        </button>
        <p className="tiny muted">
          Trouble signing in? Contact your manager for support.
        </p>
      </div>
    </div>
  );
}
